import { Box } from "@mui/material"
import { Task, AccessAlarm } from "@mui/icons-material"
import { TopToolbar, useGetOne, useRecordContext } from 'react-admin'
import DownloadPdfButton from './actionButtons/DownloadPdfButton'
import SendInvoiceReminderButton from './actionButtons/SendInvoiceReminderButton'
import { InvoiceReadModel, InvoiceReminderReadModel } from "../GeneratedClients/FreeBillApi"
import BreadCrumbs from "../invoiceCorrelations/BreadCrumbs"

const InvoiceReminderShowActions = () => {

  const invoiceReminder = useRecordContext<InvoiceReminderReadModel>()
  //@ts-ignore
  const { data: invoice } = useGetOne<InvoiceReadModel>("invoices", {id: invoiceReminder?.invoiceId}, {enabled: !invoiceReminder})
  if(!invoiceReminder) return null

  return (
    <TopToolbar>
      <Box display={"flex"} justifyContent={"space-between"} width={"100%"}>
        <Box pt={0.5}>
          <BreadCrumbs 
            links={[
              {
                title: invoice?.textModel?.heading, 
                href: `/#/invoices/${invoiceReminder.invoiceId}/show`,
                icon: <Task sx={{ mr: 0.5 }} fontSize="inherit" />
              },
              {
                title: invoiceReminder.textModel?.heading, 
                href: `/#/invoiceReminders/${invoiceReminder.id}/show`,
                icon: <AccessAlarm sx={{ mr: 0.5 }} fontSize="inherit" />
              }
            ]}
          />
        </Box>
        <Box>
          <DownloadPdfButton />
          <SendInvoiceReminderButton />
        </Box>
      </Box>
    </TopToolbar>
  )
}

export default InvoiceReminderShowActions